import { render, staticRenderFns } from "./SingularityOption.vue?vue&type=template&id=3bdb3774&"
import script from "./SingularityOption.vue?vue&type=script&lang=ts&"
export * from "./SingularityOption.vue?vue&type=script&lang=ts&"
import style0 from "./SingularityOption.vue?vue&type=style&index=0&id=3bdb3774&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports